import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>
			<div className="projects-container">
				<div className="title projects-title">{INFO.project.title}</div>

				<div className="subtitle projects-subtitle">
					{INFO.project.description}
				</div>

				<div className="projects-list">
					<AllProjects />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
